module.exports = __webpack_public_path__ + "static/media/life-sphere.b39f3f40.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/life-sphere.png
// module id = 116
// module chunks = 48